import { setEntityCover, type CoverEntityType } from '../api/entity-covers';
import { html, toast } from '../lib/dom';
import { icon } from './icons';
import { coverThumb } from './thumb';

export function coverEditor(entity: any, type: CoverEntityType, className = '') {
  const label = entity.cover?.asset_id ? 'Change image' : 'Upload image';
  return html`<div class="cover-editor ${className}">
    ${coverThumb(entity, 'thumb fill')}
    <button class="btn sm cover-editor-button" type="button" data-cover-open="${type}:${entity.id}" title="${label} · JPEG, PNG, WebP or SVG · up to 20 MB" aria-label="${label} for ${entity.name}">${icon('gallery')}<span>${label}</span></button>
    <input class="cover-editor-input" type="file" accept="image/jpeg,image/png,image/webp,image/svg+xml,.svg" data-cover-file="${type}:${entity.id}" aria-label="Choose ${type} cover image">
  </div>`;
}

export function bindCoverEditors(root: ParentNode, onSaved?: () => void) {
  root.querySelectorAll<HTMLButtonElement>('[data-cover-open]').forEach(button => {
    const key = button.dataset.coverOpen;
    const input = root.querySelector<HTMLInputElement>(`[data-cover-file="${key}"]`);
    if (!input) return;
    button.addEventListener('click', () => input.click());
    input.addEventListener('change', async () => {
      const file = input.files?.[0];
      if (!file || !key) return;
      const [type, id] = key.split(':') as [CoverEntityType, string];
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      const label = button.querySelector('span');
      const originalLabel = label?.textContent || 'Change image';
      if (label) label.textContent = 'Uploading…';
      try {
        await setEntityCover(type, id, file);
        toast('Cover image updated');
        onSaved?.();
      } catch (error) {
        toast(error instanceof Error ? error.message : 'Could not update cover image');
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (label) label.textContent = originalLabel;
        input.value = '';
      }
    });
  });
}
